export const FEATURES = {
  roomBooking: 'room_booking'
}
